/* eslint-disable require-atomic-updates */
//TODO consider difference between usersactions and userActions
import * as firebaseHelpers from '../helpers/Firebase/';
import { downloadCSV } from '../utils';
import * as types from './actionTypes';
import { setLoading } from './loaderActions';

export function downloadGivingReport(email) {
  return async (dispatch, getState) => {
    async function getUserTransaction(organizationId, displayName, uid, dataFormatted) {
      const userTransactions = await firebaseHelpers.getCollection(
        `users/${uid}/transactions`,
        ['organization', '==', organizationId]
      );

      dataFormatted.push(
        ...userTransactions.map(data => ({
          ...data,
          last4: data.last4 || ' ',
          organization: displayName,
        }))
      );
    }

    try {
      const { accountData: { details: { id: organizationId, displayName } } } = getState().userReducer;
      dispatch(setLoading(true));
      const users = await firebaseHelpers.getCollection('users', [
        ['profile.email', '==', email],
      ]);
      let dataFormatted = [];
      let promises = [];

      for (var user of users) {
        if (!user) {
          throw new Error('This user could not be found');
        }

        const { __id: uid } = user;
        promises.push(getUserTransaction(organizationId, displayName, uid, dataFormatted));
      }
      await Promise.all(promises);
      const { profile: { firstName, lastName } } = users[0];

      downloadCSV(
        dataFormatted,
        [
          'month',
          'day',
          'year',
          'organization',
          'fund',
          'last4',
          'id',
          'amount',
        ],
        `${firstName} ${lastName} - Giving Report`
      );
      dispatch(setLoading(false));
      return true;
    } catch (e) {
      alert(e.message || e);
      dispatch(setLoading(false));
      return false;
    }
  };
}

export function loadUsers() {
  return (dispatch, getState) => {
    const { user, accountData } = getState().userReducer;
    const { details: { id: organizationId } = {} } = accountData || {};

    async function addGetUserDoc(users, id) {
      const userDoc = await firebaseHelpers.getDocument(`users/${id}`);

      if (userDoc && userDoc.profile) {
        const userTransactions = await firebaseHelpers.getCollection(
          `users/${id}/transactions`
        );
        const userAlreadyExists = users[id];

        if (userAlreadyExists) {
          userAlreadyExists.totalDonations += getTransactionsTotal(userTransactions, organizationId);
        } else {
          userDoc.totalDonations = getTransactionsTotal(userTransactions, organizationId);
          users[id] = userDoc;
          users[id].name = `${userDoc.profile.firstName} ${userDoc.profile.lastName}`.trim();
        }
      }
    }

    if (user) {
      const users = {};

      firebaseHelpers.watchCollectionChanges(
        `organizations/${user.uid}/users`,
        userList => {
          const promises = [];

          for (var __user of userList) {
            const { __id: id } = __user;
            promises.push(addGetUserDoc(users, id));
          }
          Promise.all(promises).then(() => {
            const usersFormatted = Object.keys(users).map(key => users[key]);

            dispatch({
              type: types.LOAD_USERS,
              users: usersFormatted,
            });
          });
        }
      );
    }
  };
}

function getTransactionsTotal(transactions, organizationId) {
  let total = 0;

  transactions.forEach(({
    amount, status, organization,
  }) => {
    if (status === 'accepted' && organization === organizationId) {
      total += parseFloat(amount * 100);
    }
  });
  return parseFloat(total / 100);
}
